import { FC } from 'react'
import styles from 'components/features/creditCard/creditCardPanes/paneComponents/CardPaymentMethodItem.styl'
import { CCPaymentMethod } from 'components/features/creditCard/creditCardStore/types'
import { DeletePaymentMethodActionButton } from 'components/features/pfm/Button/ActionButtons'
import SvgIcon from 'components/atoms/SvgIcon'
import CheckingSvg from 'icons/withdrawals_checks.svg'
import SavingsSvg from 'icons/savings.svg'
import Flex from 'components/atoms/Flex/Flex'
import { getPaymentMethodTitle } from 'components/features/creditCard/creditCardStore/helpers'
import { deletePaymentMethodRequestSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'


type CCPaymentMethodItemProps = {
  method: CCPaymentMethod
}

const CCPaymentMethodItem: FC<CCPaymentMethodItemProps> = ({ method }) => {
  const title = getPaymentMethodTitle(method)
  const { uid, number_last_digits, account_type, status } = method
  const request = useStoreSelector(deletePaymentMethodRequestSelector)
  return (
    <Flex
      className={ styles.paymentMethod }
      component='li'
      gap='spread'
      horizontal
      verticallyCenter
    >
      <Flex horizontal verticallyCenter>
        <i>
          <SvgIcon src={ account_type === 'checking' ? CheckingSvg : SavingsSvg } />
        </i>
        <Flex gap='none'>
          <h3>{ title }</h3>
          <small>Ending in { number_last_digits }</small>
        </Flex>
        {
          status === 'removal-pending'
            ? <small>Removing...</small>
            : (
              <DeletePaymentMethodActionButton
                text='Remove'
                style='textOnly'
                size='mini'
                uid={ uid }
                fullWidth={ false }
                isSubmitting={ request?.isLoading && request?.uid === uid }
              />
            )
        }
      </Flex>
    </Flex>
  )
}

export default CCPaymentMethodItem
